import axios from 'axios'
import { client as careerClient } from './career-client/client.gen'

const api = axios.create({
  baseURL: '/.netlify/functions',
  headers: {
    'Content-Type': 'application/json',
  },
})

careerClient.setConfig({
  baseUrl: 'https://europe-north1-redrecruit-c5d13.cloudfunctions.net/api',
})

export default api
